import { createAsyncThunk } from '@reduxjs/toolkit';

import {
    PatchCatalogItemsRequest,
    PatchCatalogItemsResponse,
} from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { fetchInventoryItems } from 'widgets/InventoryTable/model/services/fetchCatalogItems/fetchInventoryItems';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const editMinAllowedService = createAsyncThunk<
    PatchCatalogItemsResponse,
    PatchCatalogItemsRequest,
    ThunkConfig<any>
>('catalogItem/editMinAllowed', async ({ data, catalogId }, thunkApi) => {
    const { dispatch, extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.patch<PatchCatalogItemsResponse>(
            `/v1/catalogs/${catalogId}/items`,
            data,
        );

        await dispatch(fetchInventoryItems(catalogId));
        return response.data;
    } catch (e) {
        return rejectWithValue(e);
    }
});
